export default __webpack_public_path__ + "static/media/turkey_white_male.77a6d465.png";